module.exports = __webpack_public_path__ + "img/knu2_gallery15.48eac858.jpg";